/** @format */

import { DirectiveStylesService } from '../services/directive-styles.service';
import { NgModule } from '@angular/core';
import { RunScriptsDirective } from './run-scripts.directive';
import { ScrollbarsDirective } from './scrollbars.directive';

/**
 * @description
 * Module for common pipes, components, directives, services, etc. Services should all be singletons and exported as
 * providers for root only.
 */
@NgModule({
	/*
	 * Module imports
	 */
	imports: [],

	/*
	 * Module declarations
	 */
	declarations: [
		RunScriptsDirective,
		ScrollbarsDirective
	],

	/*
	 * Module providers
	 */
	providers: [DirectiveStylesService],

	/*
	 * Module exports
	 */
	exports: [
		RunScriptsDirective,
		ScrollbarsDirective
	]
})
export class HomeDirectiveModule {}
